import React from "react";
export const UserTrafficColumnFormatter = (cellContent, row) => (
  <span
    className={`label label-lg label-light-${getColor(row.trafficTypeCode)
      } label-inline `}
  >
    {row.trafficTypeTitle}
  </span>
);

export const UserTrafficOColumnFormatter = (cellContent, row) => (
  <span
    className={`label label-lg label-light-${getColor(row.originalTrafficTypeCode)
      } label-inline`}
  >
    {row.originalTrafficTypeTitle}
  </span>
);

// export const ObjectCssClasses = ["info", "info", "info", "danger", "danger", "danger", "success", "success", "success", "warning", "warning", "warning", "warning", "warning", "warning", "warning"];

const getColor = (code) => {

  switch (code) {
    case 16:
      return "info";
    case 17:
      return "info";
    case 18:
      return "info";

    case 32:
      return "danger";
    case 33:
      return "danger";
    case 34:
      return "danger";

    case 48:
      return "success";
    case 49:
      return "success";
    case 50:
      return "success";

    case 64:
      return "warning";
    case 65:
      return "warning";
    case 66:
      return "warning";
    case 67:
      return "warning";
    case 68:
      return "warning";
    case 69:
      return "warning";
    case 70:
      return "warning";


    default:
      break;
  }
}